export default __webpack_public_path__ + "static/media/i2.239f9100.webp";